import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_storage_messagesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { notes?: string, status?: string, process?: string, reference?: string, sender?: string, receiver?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, modified_on?: string, direction?: string, integration_name?: string, request_id?: string, environment?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, status?: string, direction?: string, process?: string, reference?: string, sender?: string, receiver?: string, payload?: string, notes?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, request_id?: string, integration_name?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, environment?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { notes?: string, status?: string, process?: string, reference?: string, sender?: string, receiver?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, modified_on?: string, direction?: string, integration_name?: string, request_id?: string, environment?: string, $keys: string[] }): Promise<{ result?: { id?: string, status?: string, direction?: string, process?: string, reference?: string, sender?: string, receiver?: string, payload?: string, notes?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, request_id?: string, integration_name?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, environment?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      notes?: string, status?: string, process?: string, reference?: string, sender?: string, receiver?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, modified_on?: string, direction?: string, integration_name?: string, request_id?: string, environment?: string    }) {
      return false;
    }
}
